export class DocumentType {
    Id: number;
    ExternalId: string;
    Tenant: number;
    Name: string;
    Code: string;
}